import {css, cx} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {Block} from './Block';
import {Button} from './Button';
import {
  calculateGiftCardCashoutValue,
  formatValueToDollar,
  GIFT_CARD_FACTOR,
  theme,
} from './Common';
import {Modal} from './Modal';
import {Span} from './Span';
import {TextInput} from './TextInput';

export type CustomerPortalModalGiftCardProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => unknown;
  setEmail: (value: string) => unknown;
  email: string;
  amount: number;
  setAmount: (value: string) => unknown;
  nextClick: () => unknown;
};
const extraPercentage = Math.round((GIFT_CARD_FACTOR - 1) * 100);

export const CustomerPortalModalGiftCard = ({
  isOpen,
  setIsOpen,
  email,
  setEmail,
  nextClick,
  amount,
}: CustomerPortalModalGiftCardProps) => (
  <Modal title='Gift Card' isOpen={isOpen} setModal={setIsOpen}>
    <Content style={{maxWidth: '545px'}}>
      <Span fontColor='darkGray' fontSize='medium' fontWeight='bold' style={{maxWidth: '440px'}}>
        Get {extraPercentage}% more{' '}
        <Span fontColor='darkGray' fontSize='medium' fontWeight='normal'>
          with a Reperch Gift Card! Cash out your balance and treat yourself — or gift it to a
          friend.
        </Span>
      </Span>
      <Block
        style={{
          marginTop: theme.spacings.medium,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Span fontColor='darkGray' fontSize='small' fontWeight='normal'>
          Available
        </Span>
        <Value>
          {formatValueToDollar(calculateGiftCardCashoutValue(amount), {maximumFractionDigits: 2})}{' '}
          <Span fontColor='darkBlue' fontWeight='medium' fontSize='medium'>
            ({amount} +{extraPercentage}%)
          </Span>
        </Value>
      </Block>
      <TextInput
        type='email'
        placeholder='Gift Card E-mail Address'
        value={email}
        setValue={setEmail}
        containerClassName={css({width: '100%'})}
      />
      <Button
        buttonStyle='primary'
        onClick={nextClick}
        className={buttonAditionalStyle}
        disabled={!email}
      >
        <Span fontColor='darkBlue' fontSize='small' fontWeight='bold'>
          Withdraw
        </Span>
      </Button>
    </Content>
  </Modal>
);
const Content = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    })}
    {...args}
  />
);
const buttonAditionalStyle = css({marginTop: theme.spacings.medium});

const textBase = css({
  color: theme.colors.darkGray,
  fontFamily: theme.font.family,
  fontSize: theme.font.sizes.medium,
  fontWeight: theme.font.bold,
  textAlign: 'left',
});
const Value = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={cx(
      textBase,
      css({
        color: theme.colors.darkBlue,
        fontSize: theme.font.sizes.large,
        marginTop: theme.spacings.xxsmall,
      }),
    )}
    {...args}
  />
);
